import { MessageCircle, MapPin } from "lucide-react";
import { LOGO_FULL, PHONE, PHONE_LINK, EMAIL, EMAIL_LINK, WHATSAPP_LINK, ADDRESS, MAPS_LINK, scrollTo } from "@/lib/site";

const COMPANY = [["Home", "#home"], ["Services", "#services"], ["Pricing", "#pricing"], ["Our Work", "#work"], ["Process", "#process"], ["Contact", "#contact"]];
const SERVICES = ["Business Websites", "Small Business Websites", "E-Commerce", "Restaurant Websites", "Salon Websites", "Clinic Websites", "Custom Websites"];

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 bg-ink">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-2 md:px-12 lg:grid-cols-4">
      <div>
        <div className="inline-flex items-center gap-3 rounded-xl bg-white p-2.5 pr-4">
          <img src={LOGO_FULL} alt="Falkeen Technologies" className="h-9 w-auto object-contain" />
        </div>
        <p className="mt-5 font-display text-[10px] font-bold uppercase tracking-[0.3em] text-accent">
          Your Business. Our Technology.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-zinc-500">
          Premium website design and development for businesses, startups and professionals.
        </p>
      </div>
      <div>
        <h4 className="font-display text-xs font-extrabold uppercase tracking-[0.25em] text-white">Company</h4>
        <ul className="mt-5 space-y-2.5">
          {COMPANY.map(([label, hash]) => (
            <li key={label}>
              <a
                href={hash}
                onClick={(e) => { e.preventDefault(); scrollTo(hash); }}
                data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-sm text-zinc-500 transition-colors duration-300 hover:text-accent"
              >
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-display text-xs font-extrabold uppercase tracking-[0.25em] text-white">Services</h4>
        <ul className="mt-5 space-y-2.5">
          {SERVICES.map((s) => (
            <li key={s}>
              <a
                href="#services"
                onClick={(e) => { e.preventDefault(); scrollTo("#services"); }}
                className="text-sm text-zinc-500 transition-colors duration-300 hover:text-accent"
              >
                {s}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-display text-xs font-extrabold uppercase tracking-[0.25em] text-white">Contact</h4>
        <ul className="mt-5 space-y-3 text-sm text-zinc-500">
          <li>
            <a href={PHONE_LINK} data-testid="footer-phone-link" className="transition-colors duration-300 hover:text-accent">{PHONE}</a>
          </li>
          <li>
            <a href={EMAIL_LINK} data-testid="footer-email-link" className="break-all transition-colors duration-300 hover:text-accent">{EMAIL}</a>
          </li>
          <li>
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="inline-flex items-center gap-2 text-[#25D366] transition-colors duration-300 hover:brightness-125">
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
          </li>
          <li className="flex items-start gap-2">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-accent" strokeWidth={1.5} />
            <span data-testid="footer-address" className="leading-relaxed">
              FALKEEN TECHNOLOGIES
              <br />
              {ADDRESS}
            </span>
          </li>
          <li>
            <a
              href={MAPS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-directions-link"
              className="inline-flex items-center gap-1.5 font-display text-[10px] font-bold uppercase tracking-[0.2em] text-accent transition-colors duration-300 hover:text-white"
            >
              <MapPin className="h-3.5 w-3.5" /> Get Directions
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 text-xs text-zinc-600 md:flex-row md:px-12">
        <p>© 2026 Falkeen Technologies. All Rights Reserved.</p>
        <div className="flex gap-6">
          <a href="/privacy" data-testid="footer-privacy" className="transition-colors duration-300 hover:text-zinc-400">Privacy Policy</a>
          <a href="/terms" data-testid="footer-terms" className="transition-colors duration-300 hover:text-zinc-400">Terms & Conditions</a>
        </div>
      </div>
    </div>
  </footer>
);
